import { isStw } from '@/utils/environment';

const BALANCE_LIMIT = -1000000;

/**
 * Do not show the balance card on ST if the user:
 * - Has a balance in debit over £10,000.00
 */
export const isBalanceHidden = (balance: number) =>
  isStw() && balance <= BALANCE_LIMIT;
